import React, { memo, useCallback } from 'react';
import { NavLink } from 'react-router-dom';

type SideNavbarLinkProps = {
  to: string;
  link: string;
  icon: React.ReactNode;
};

const SideNavbarLink: React.FC<SideNavbarLinkProps> = memo(
  ({ link, to, icon }) => {
    const navLinkClassGenerator = useCallback(
      ({ isActive }: { isActive: boolean }) =>
        `hover:underline mt-3 justify-start items-center py-2 px-6 w-full flex border-2 rounded-full ${
          isActive
            ? 'text-primary bg-light-green font-medium '
            : 'border-[rgba(0,0,0,0)]'
        }`,
      []
    );

    return (
      <NavLink className={navLinkClassGenerator} to={to}>
        <div className="mr-3">{icon}</div>
        {link}
      </NavLink>
    );
  }
);

export default SideNavbarLink;
